import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import App from './App';
import { store } from './store';
import './index.css';
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container missing in index.html');
}
const root = ReactDOM.createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsxs(BrowserRouter, { children: [_jsx(CssBaseline, {}), _jsx(App, {})] }) }) }));
